import { createAsyncThunk } from '@reduxjs/toolkit';

import { reportError } from '@/shared/utils/reportError';

import {
  CertificadoCompleto,
  GerarCertificadoPdfResponse,
  RenderUrlPdfRequest,
  RenderUrlPdfResponse,
} from '../types';
import { certificadoService } from './services';

export const buscarCertificadoPorItem = createAsyncThunk<CertificadoCompleto, string>(
  'certificado/buscarPorItem',
  async (itemId, { rejectWithValue }) => {
    try {
      return await certificadoService.getByItemId(itemId);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Erro ao buscar certificado';
      return rejectWithValue(message);
    }
  },
);

// Recarga com o certificado já na tela, ANTES de liberar o download do PDF, quando o PDF pronto é
// de uma versão mais nova que a da tela (`sincronizarPdfComATela`). Não passa pelo `isLoading` nem
// pelo `error` da busca: trocaria a tela já aberta pelo "Carregando" ou, numa falha, pelo
// "Certificado não encontrado".
export const atualizarCertificadoPorItem = createAsyncThunk<
  CertificadoCompleto,
  string,
  { rejectValue: string }
>('certificado/atualizarPorItem', async (itemId, { rejectWithValue }) => {
  try {
    return await certificadoService.getByItemId(itemId);
  } catch (error) {
    const erro = error instanceof Error ? error : new Error('Erro ao atualizar certificado');
    reportError(erro, { source: 'certificado.atualizarPorItem', itemId });
    return rejectWithValue(erro.message);
  }
});

export const buscarCertificadoPorMessage = createAsyncThunk<CertificadoCompleto, string>(
  'certificado/buscarPorMessage',
  async (messageId, { rejectWithValue }) => {
    try {
      return await certificadoService.getByMessageId(messageId);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Erro ao buscar certificado';
      return rejectWithValue(message);
    }
  },
);

export const renderCertificadoPdf = createAsyncThunk<
  RenderUrlPdfResponse,
  RenderUrlPdfRequest,
  { rejectValue: string }
>('certificado/renderCertificadoPdf', async (payload, { rejectWithValue }) => {
  try {
    return await certificadoService.renderUrlPdf(payload);
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Falha ao gerar PDF';
    return rejectWithValue(message);
  }
});

export const gerarCertificadoPdfServerSide = createAsyncThunk<
  GerarCertificadoPdfResponse,
  { itemId: string },
  { rejectValue: string }
>('certificado/gerarPdfServerSide', async ({ itemId }, { rejectWithValue }) => {
  try {
    return await certificadoService.gerarPdfServerSide(itemId);
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Falha ao gerar PDF do certificado';
    return rejectWithValue(message);
  }
});
